import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import dxAccordion from 'devextreme/ui/accordion';
import { IAbcComponent } from '../abcComponent.model';

@Component({
  selector: 'abcExpansionPanel',
  template: `
    <ng-container *ngTemplateOutlet="style == 4 ? devExpress : material"> </ng-container>

    <ng-template #devExpress>
      <dx-accordion
        #dxAccordion
        [collapsible]="collapsible"
        [selectedIndex]="selectedIndex"
        [multiple]="multiple"
        [animationDuration]="[animationDuration]"
        [height]="attrheight"
        [width]="attrWidth"
        (onSelectionChanged)="openCloseGroup($event)"
        [disabled]="disabled"
        [rtlEnabled]="rtlEnabled"
        [visible]="visible"
        [class]="class"
      >
        <dxi-item icon="{{ attrImage }}" title="{{ tooltip }}">
          <div *dxTemplate>
            <ng-content select="[content=devExpress]"> </ng-content>
          </div>
        </dxi-item>
      </dx-accordion>
    </ng-template>

    <ng-template #material>
      <mat-expansion-panel
        #expansionPanel
        [class]="class"
        [ngClass]="defaultClass == true ? 'Expansion-style' : ''"
        [expanded]="allExpandState"
        [expanded]="expanded"
      >
        <mat-expansion-panel-header
          (click)="openCloseGroup($event)"
          [collapsedHeight]="collapsedHeight"
          [expandedHeight]="expandedHeight"
        >
          <mat-panel-title matTooltip="{{ tooltip }}">
            <img *ngIf="attrImage" src="{{ attrImage }}" style="padding-right: 10px; height: 16px; width: 16px;" />
            <ng-content select="[header]"></ng-content>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-content select="[content=material]"></ng-content>
      </mat-expansion-panel>
    </ng-template>
  `,
  styleUrls: ['./abcExpansion.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AbcExpansionComponent implements IAbcComponent {
  @Input('source') attrSource;
  @ViewChild('abcExpansionPanel', { static: true, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  @ViewChild('expansionPanel') expansionPanel: MatExpansionPanel;
  @ViewChild('dxAccordion') dxAccordion: dxAccordion;
  @Input('width') attrWidth: string | number;
  @Input('height') attrheight: string | number;
  @Input() collapsible: boolean;
  @Input() multiple: boolean;
  @Input('index') attrIndex;
  @Input() tooltip: string;
  @Input('image') attrImage;
  @Output() onOpen: EventEmitter<any> = new EventEmitter();
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @ViewChild('dataOutside', { static: true }) rootDiv: ElementRef<HTMLDivElement>;
  @Output() allExpandState;
  @Input() expanded;
  @Input() defaultClass: boolean = true;
  data = [];
  @Input() style;
  @Input() animationDuration = '300';
  @Input() collapsedHeight: string = '40px';
  @Input() expandedHeight: string = '40px';
  @Input() selectedIndex: number = 0;
  @Input() disabled: boolean = false;
  @Input() visible: boolean = true;
  @Input() rtlEnabled: boolean = false;
  @Input() class: string;
  private componentRef;
  get id(): string {
    return 'expansion';
  }
  ngOnInit() {}

  constructor() {}

  openCloseGroup(event) {
    if (this.expansionPanel?.expanded || event.addedItems?.length > 0) {
      this.onOpen.emit(event);
    } else {
      this.onClose.emit(event);
    }
  }
}

@Component({
  selector: 'abcAccordion',
  template: `<mat-accordion #accordion="matAccordion">
    <ng-content select="[content]"></ng-content>
  </mat-accordion>`,
  styles: [],
})
export class AbcAccordionComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
